import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../Context/AppContext";
import { useMain } from "./Main";

export const useChat = () => {
    const { webSocket, user } = useAppContext();
    const { state, setData, Request } = useMain();
    const { rooms, room, newmessage, sended } = state;
    const [connected, setconnected] = useState(false)
    const [id, setid] = useState()
    const [item, setitem] = useState()
    const [loadSendFile, setLoadSendFile] = useState(false)
    const [modal, setModal] = useState(false)
    const [showModal, setShowModal] = useState(false)
    const [txt, setTxt] = useState('')
    const navigate = useNavigate();
    useEffect(() => {
        const url = new URL(window.location.href);
        const ID = url.searchParams.get("id");
        const IDITEM = url.searchParams.get("item");
        if (ID) {
            setid(ID)
        }
        if (IDITEM) {
            setitem(IDITEM)
        }
    }, []);

    useEffect(() => {
        if (room) {
            if (!showModal) {
                if (room.item) {
                    if (room.item.shop) {
                        setShowModal(true);
                        setModal(true);
                    }
                }
            }
        }
    }, [room])


    useEffect(() => {
        if (newmessage) {
            if (newmessage.room_id == id) {
                setData('room', { ...room, chats: [...room.chats, newmessage.message] });
                return;
            }
            if (newmessage.item_id == item) {
                setData('room', { ...room, chats: [...room.chats, newmessage.message] });
                return;
            }
        }
    }, [newmessage])

    if (webSocket) {

        if (webSocket.readyState) {
            if (!connected) {
                setconnected(true)
            }
        }

        webSocket.onopen = () => {
            send('rooms');
            setconnected(true)
        }

        webSocket.onmessage = ({ data }) => {
            const res = JSON.parse(data);
            if (Array.isArray(state[res.key])) {
                setData(res.key, [...state[res.key], ...res.data]);
                return;
            }
            if (typeof state[res.key] == "object") {
                setData(res.key, { ...state[res.key], ...res.data });
                return;
            }
            setData(res.key, res.data);
            return;
        }

        webSocket.onerror = () => {
            setconnected(false);
        }

    }



    const send = (action, msg) => {

        webSocket.send(JSON.stringify({ action, token: user.token, ...msg }))

    }

    const getRooms = () => {
        send('rooms')
    }

    const getRoom = () => {

        send('room', { id: id, item: item })
    }

    const blocked = () => {
        send('blocked', { id: id })
    }


    const deleted = () => {
        send('deleted', { id: id });
        navigate('/Messages');
    }

    const sendMessage = (msg) => {
        let code = Math.random();
        newMessage(msg, code)
        send('newmessage', { id: id, item: item, message: msg, code: code })
    }

    const sendFile = ({ target }) => {
        setLoadSendFile(true)
        Request({
            url: '/upload-image',
            props: {
                image: target.files
            },
            callback: (res) => {
                target.value = null;
                setLoadSendFile(false)
                if (res) {
                    let code = Math.random();
                    newMessage(res.url, code, 'file')
                    send('newmessage', { id: id, item: item, message: res.url, code: code, type: 'file' })

                }
            }
        })
    }
    const newMessage = (msg, code, type = 'text') => {

        setData('room', {
            ...room, chats: [...room.chats, {
                code: code,
                chat_sender: user.id,
                chat_message: msg,
                chat_mimetype: type,
                created_at: new Date(),
            }]
        });
        setTxt('');
    }


    return {
        id, item,
        connected,
        getRooms, getRoom, blocked, deleted,
        sendFile, sendMessage,
        loadSendFile,
        modal, setModal,
        rooms, room, user,
        setTxt, txt,
        navigate
    }

}